import { createStyles } from '@material-ui/core/styles';
import spacings from '../spacing';

export default createStyles({
  root: {
    '& .MuiDialogContent-root': {
      padding: 0,
    },
    '& .MuiDialogActions-root': {
      padding: `${spacings.xsmall} ${spacings.small}`,
    },
    '& .MuiDialog-paperWidthSm': {
      maxWidth: 629,
    },
    '& .MuiDialog-paperWidthMd': {
      maxWidth: 673,
    },
  },
});
